import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpenthreadDashboardComponent } from './openthread-dashboard/openthread-dashboard.component';

import {
  NbAuthComponent,
  NbLoginComponent,
  NbRegisterComponent,
  NbLogoutComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';

const routes: Routes = [
  { path: '', redirectTo: 'openthread', pathMatch: 'full' },
  { path: 'openthread', loadChildren: () => import('./openthread-dashboard/openthread-dashboard.module').then(m => m.OpenthreadDashboardModule), },
  { path: 'fit20', loadChildren: () => import('./fit20/fit20.module').then(m => m.Fit20Module), },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
